/*
 * Public API Surface of common configuration
 */
export * from './index';

/** AUGMENTABLE_TYPES_START */
export { ProductConfiguratorConfig } from './core/model/product-configurator.config';
/** AUGMENTABLE_TYPES_END */
